import { Observable } from 'rxjs';
import { Session } from './session';

export abstract class SessionRepository {
  abstract getAll(): Observable<Session[]>;
  abstract create(session: Session): Observable<Session>;
  abstract update(session: Session): Observable<Session>;
  abstract delete(id: number): Observable<void>;
  abstract activate(id: number): Observable<void>;
  abstract exportCsv(): Observable<Blob>;
  abstract exportExcel(): Observable<Blob>;
}
